import DogNameGen from "./pages/DogNameGen";
import CatNameGen from "./pages/CatNameGen";
import Header from "./components/Header";
import Grid from "@mui/material/Grid";
import "../src/assets/styles/index.css";
import configData from "./assets/inc/config.json";

function App() {
  //const store = configureStore()
  return (
    <div>
      <Grid container justifyContent="center" alignItems="flex-start">
        <Grid item xs={12} md={12}>
          <Header petType={configData.pet_type} />
        </Grid>
        <Grid container item xs={12} md={12}>
          {configData.pet_type === "cat" ? <CatNameGen /> : <DogNameGen />}
        </Grid>
      </Grid>
    </div>
  );
}

export default App;
